export const dashboardCanvasAddButtonHoverStyles = {
  '&:hover,:focus-within': {
    '.dashboard-canvas-add-button': {
      opacity: 1,
      filter: 'unset',
    },
  },
};
